import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import TrialState from "../../../models/state/trials/trial/TrialState";
import TrialsState from "../../../models/state/trials/TrialsState";
import * as trialStateSelectors from "./wrongAnswers";

export const getWrongAnswersTrialState = (state: TrialsState): TrialState => {
  return state.wrongAnswers as TrialState;
};

// wrong answers trial

export const hasWrongAnswersPremiumTrial: (arg0: TrialsState) => boolean =
  composeSelector(
    getWrongAnswersTrialState,
    trialStateSelectors.hasWrongAnswersPremiumTrial
  );

export const getWrongAnswersSessionsInitiallyGranted: (
  arg0: TrialsState
) => number = composeSelector(
  getWrongAnswersTrialState,
  trialStateSelectors.getWrongAnswersSessionsInitiallyGranted
);

export const getWrongAnswersSessionsRemaining: (arg0: TrialsState) => number =
  composeSelector(
    getWrongAnswersTrialState,
    trialStateSelectors.getWrongAnswersSessionsRemaining
  );

export const canStudyWrongAnswersSession: (arg0: TrialsState) => boolean =
  composeSelector(
    getWrongAnswersTrialState,
    trialStateSelectors.canStudyWrongAnswersSession
  );

export const userHasFinishedWrongAnswersTrial: (arg0: TrialsState) => boolean =
  composeSelector(
    getWrongAnswersTrialState,
    trialStateSelectors.userHasFinishedWrongAnswersTrial
  );
